import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23a989bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "intro" }

import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import UIIntroSteps from '@/components/UIIntroSteps/UIIntroSteps.vue';
import { useAppState } from '@/services/composition';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n()
const { send } = useAppState()

const step = ref(1)
const stepCount = ref(3)

const key = computed(() => {
  return step.value >= stepCount.value ? 'final' : 'pending'
})

const buttonLabel = computed(() => {
  return step.value >= stepCount.value ? t('intro.start') : t('intro.skip')
})

const next = () => {
  send('GAME_INTRO_NEXT_STEP')
  if(step.value >= stepCount.value) return
  step.value ++
}

return (_ctx: any,_cache: any) => {
  const _component_ui_btn = _resolveComponent("ui-btn")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "long-fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(UIIntroSteps, {
          step: step.value,
          "step-count": stepCount.value,
          onNext: next
        }, null, 8, ["step", "step-count"]),
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("div", {
              class: "actions",
              key: _unref(key)
            }, [
              _createVNode(_component_ui_btn, {
                class: "btn-skip",
                variant: "secondary",
                onClick: next
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(buttonLabel)), 1)
                ]),
                _: 1
              })
            ]))
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})